import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import ValidatedInput from "../common/ValidatedInput";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval, noOfChannels } = formData;
  const { setFormData } = useContext(FormDataContext);
  const availableContent = [
    { label: "Events", value: "events" },
    { label: "Incidents", value: "incidents" }
  ];
  const [contentTypes, setContentTypes] = useState("");
  const [contentTypeVal, setContentTypeVal] = useState(false);
  const { checkpointIntervalSeconds, streamGUID } = formData;
  const contentArray = contentTypes.split(",");
  const handleSubmit = () => {
    const isPresent = contentArray.includes("events");
    let error = false;
    formData.contentTypes.value = contentTypes;
    if (isPresent && streamGUID.value === " ") {
      setFormError({
        full_message: "Please provide GUID of your Event Stream",
        nice_message: "Stream GUID is required for event streaming."
      });
      error = true;
    }
    if (contentTypes.length === 0) {
      setContentTypeVal(true);
      error = true;
    }
    if (checkpointIntervalSeconds.value < 5) {
      setFormError({
        full_message: "Please provide valid checkpoint interval",
        nice_message: "Minimum allowable checkpoint interval is 5 seconds."
      });
      error = true;
    }
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: "Please provide valid polling interval",
        nice_message: "Minimum allowable polling interval is 1 minute."
      });
      error = true;
    }
    if (!error) {
      setFormError(null);
      onSubmit();
    }
  };
  const handleContentType = (val) => {
    const value = { value: val, dirty: false };
    setFormData("logTypes", value);
    setContentTypes(val);
    setContentTypeVal(false);
  };
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: handleSubmit, buttonContent: "Proceed", title: "", error: formError, description: "" }, /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, "Logs Types to Collect"), /* @__PURE__ */ React.createElement(
    Select,
    {
      multi: true,
      name: "content_type",
      id: "contentTypes",
      onChange: handleContentType,
      options: availableContent,
      value: contentTypes || ""
    }
  ), contentTypeVal && contentTypes.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "contentTypes" }, "Select at least one"), /* @__PURE__ */ React.createElement("span", { className: "help-block" }, "The activity log for the above content types will be fetched."), contentArray.includes("events") && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      className: "",
      id: "streamGUID",
      type: "text",
      onChange,
      fieldData: formData.streamGUID,
      label: "Stream GUID",
      help: "Unique identifier of event stream (GUID).",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "noOfChannels",
      name: "noOfChannels",
      type: "number",
      value: noOfChannels.value || noOfChannels.defaultValue || "",
      min: "1",
      max: "60",
      step: "1",
      onChange,
      required: true,
      help: "The numbers of channels in the Event Stream.",
      label: "Number of Channels"
    }
  )), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pollingInterval",
      name: "pollingInterval",
      type: "number",
      value: pollingInterval.value || pollingInterval.defaultValue || "",
      min: "1",
      max: "60",
      step: "1",
      onChange,
      required: true,
      help: "Determines how often (in minutes) new Incidents in Symantec SES will be checked. The smallest allowable interval is 1 minute.",
      label: "Polling Interval"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "checkpointIntervalSeconds",
      name: "checkpointIntervalSeconds",
      type: "number",
      value: checkpointIntervalSeconds.value || checkpointIntervalSeconds.defaultValue || "",
      min: "1",
      max: "60",
      step: "1",
      onChange,
      required: true,
      help: "How often (in seconds) record checkpoints for Symantec SES log collection will be checked.",
      label: "Checkpoint Interval"
    }
  ), /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange, selectedContentTypes: contentTypes }));
};
export default StepSubscribe;
